import { AccentFoldService, AddOnTypes, AppService, CommonMapService, CoreProxyService, CoreTypes, IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts, LabelValue } from 'common-cloudstudio';
import { Subscription, Observable } from 'rxjs';
import { GearProxyService, GearTypes, GearAppService } from 'common-gear';
import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MapService } from '../shared/services/map.service';
import { ActivatedRoute, Router } from "@angular/router";
import { MapsAPILoader } from '@agm/core';
import { SharedService } from '../shared/services/shared.service';
import { GoogleMap } from '@angular/google-maps';
import { MarkerClusterer } from "@googlemaps/markerclusterer";


declare var environment: any;

interface Metadata {
  id: any;
}

interface IconMarker {
  latitude: number;
  longitude: number;
  url: string | google.maps.ReadonlyIcon | google.maps.ReadonlySymbol;
  html?: string;
  metadata: Metadata;
}

@Component({
  selector: 'app-device-map',
  templateUrl: './device-map.component.html',
  styleUrls: ['./device-map.component.scss']
})
export class DeviceMapComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('deviceModal') public _deviceModal: any;
  @ViewChild(GoogleMap, { static: false }) mapComponent!: GoogleMap;
  bounds: any;
  _lastOpenInfoWindow: any;
  _longitudeCenter: number = -105.012516;
  _latitudeCenter: number = 10.875404;
  _zoom: number = 1.9;
  _mapWidth: string;
  map!: google.maps.Map;
  clusterer!: MarkerClusterer;
  markers: google.maps.Marker[] = [];
  infoWindow!: google.maps.InfoWindow;

  AdvancedMarkerElement: any;
  PinElement: any;

  showIndividualMarkers: boolean = true;
  private readonly CLUSTER_ZOOM_THRESHOLD = 12;
  private currentZoom: number = 0;

  clustersFullList: {
    deviceData: CoreTypes.DeviceMap;
    markerData: IconMarker;
  }[] = [];
  clustersFilteredList: {
    deviceData: CoreTypes.DeviceMap;
    markerData: IconMarker;
  }[] = [];
  _activeMarker: number;

  _dataPacketSub: Subscription;
  _pathsUtilityCompanies: any;
  _pathsMaintenanceContractors: any;
  _deviceModalId: number;
  subscriptions: Subscription[] = [];

  _deviceModalTextAttributes: CoreTypes.TextAttributeList[];
  _successMessage: string;
  _errorMessage: string;

  _deviceID : number;
  devicesOpts : Array<IMultiSelectOption>  = [];
  devicesList : number[] = [];
  devices: number[] = [];
  devicesIDs: number[] = [];

  devicesFullList : CoreTypes.Device[];

  executionNumber: number = 0;
  searchText: string = '';
  clientID: number;
  facilityID: number;
  firstExecution: boolean = true;
  activeTab = 0;
  facilityData: GearTypes.GearMapFacility = new GearTypes.GearMapFacility();
  facilitiesIds: number[] = [];
  facilitiesList: Array<IMultiSelectOption> = [];
  _facilityID: number;
  status: number = 0;
  _facilityType: LabelValue<number>;
  _facilityTypesList: LabelValue<number>[] = new Array<LabelValue<number>>();
  _multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
    
  };
  _multiSelectTexts: IMultiSelectTexts = {
    checkAll: this._appService.CoreCommonLiterals.MultiSelect_All_Male, // 'Select all'
    uncheckAll: this._appService.CoreCommonLiterals.None_Male, // 'Unselect all'
    checked: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male, // 'item selected'
    checkedPlural: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male,
    searchPlaceholder: this._appService.CoreCommonLiterals.MultiSelect_Find, //'Find'
    defaultTitle: this._appService.CoreCommonLiterals.Select, // 'Select'
    allSelected: this._appService.CoreCommonLiterals.MultiSelect_All_Male // 'All selected'
  };
  
  facilities: number[] = [];
  _facilityParameter: CoreTypes.Facility = {
    ...new CoreTypes.Facility(),
    Location: {
      Latitude: null,
      Longitude: null
    }
  };
  _selectedFacility: LabelValue<number>[] = new Array<LabelValue<number>>();
  _defaultFacility: LabelValue<number>;
  debounceAction: any;
  initialLatitude: number;
  initialLongitude: number;
  initialZoom: number;
  mapApiReady = false;

  private _destroyed = false;
  private _sequenceNumber = 0;
  private _listoOfFacilityIcons: GearTypes.GearIcon[];
  private _clientId: number;
  private timer: any;
  private indexTable: Array<number> = [];
  private _lastClusteringData: string = '';
  private _isUpdatingClustering = false;
  private _currentTooltipMarker: google.maps.Marker | null = null;
  private _isMouseOverTooltip: boolean = false;
  private _tooltipTimeout: any;
  private _lastFacilityId: number = 0;
  googleMapOptions: any;

  addOnFeatureVisibility = AddOnTypes.AddOnVisibilityTypes;
  addOnFeatureIDs = AddOnTypes.AddOnFeatureIDs;
  addOnMapping:GearTypes.BasicMasterEntityAddOnFeatures = new GearTypes.BasicMasterEntityAddOnFeatures();
  maxPanelWidth: number = 700;
  environment = environment;

  constructor(
    public _mapService: MapService,
    public commonMapService: CommonMapService,
    private _gearProxyService: GearProxyService,
    public _appService: AppService,
    private _router: Router,
    public _gearService: GearAppService,
    public mapsAPILoader: MapsAPILoader,
    private _accentFoldService: AccentFoldService,
    private sharedService: SharedService,
    private _coreProxyService: CoreProxyService,
    private _activatedRoute: ActivatedRoute,
  ) {}

  async ngOnInit() {
    try {
      let map = await this._mapService.load();
      if(map) {
        this.mapApiReady = true;
        this.googleMapOptions = {
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_LEFT
          },
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          mapId: 'device-map-id'
        };
      }
    } catch (error) { }
    
    this.maxPanelWidth = window.innerWidth*0.7 - 260;
    this._facilityID = this._appService.getFacilityID();
    this.status = 0;
    this.addOnMapping = this._gearService.addOnFeaturesPermissionsList?.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.Mapping);
    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }
      this.status = 0;
      this._facilityID = this._appService.getFacilityID();
      this._lastClusteringData = '';
      this._isUpdatingClustering = false;
      this.getFacilities();
    }))
    this.getFacilities();

    this._activatedRoute.params.subscribe(params => {
      this._deviceID = params.deviceID;
      if(this._deviceID) this.loadDevices();
    });
  }

  ngAfterViewInit(): void {
    const waitForMap = setInterval(() => {
      if (this.mapComponent?.googleMap) {
        clearInterval(waitForMap);
        this.onMapReady(this.mapComponent.googleMap);
      }
    }, 100);
  }

  ngOnDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.debounceAction);
    this._destroyed = true;
    this.debounceAction = null;
    this._dataPacketSub?.unsubscribe();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  initData() {
    clearTimeout(this.timer);
    this._sequenceNumber = 0;
    this.status = 0;
    this.indexTable = [];
    this.clustersFullList = [];
    this.clustersFilteredList = [];
    this.searchText = '';
    this.firstExecution = true;
    
    const currentFacilityId = this._appService.getFacilityID();
    this._lastFacilityId = currentFacilityId;
    this._lastClusteringData = '';
    this._isUpdatingClustering = false;
    
    if (this.map) {
      this.map.setCenter(new google.maps.LatLng(this._latitudeCenter, this._longitudeCenter));
      this.map.setZoom(this._zoom);
      this.currentZoom = this._zoom;
      this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
    }
    this.clearClustering();
    this.getRecursively();
  }

  getRecursively() {
    this.addOnMapping = this._gearService.addOnFeaturesPermissionsList?.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.Mapping);
    if(this._destroyed || (!this.addOnMapping?.Enabled &&(this.addOnMapping?.Visibility === this.addOnFeatureVisibility.ShowStar || this.addOnMapping?.Visibility === this.addOnFeatureVisibility.Visible))) { return;}
    if(this._dataPacketSub) { this._dataPacketSub.unsubscribe(); }
    this._dataPacketSub = this.getDataPackages().subscribe(data => {
      this.getRecursively();
    }, (interval) => {
      this.timer = setTimeout(()=> this.getRecursively(), interval);
    })
  }

  getFacilities() {
    if( !this._appService.getClientID()){ return; }
    this.facilitiesList = [];
    this.facilitiesIds = [];
    this.facilities = [];
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this._coreProxyService.FacilityService.EnumFacilities(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      res => {
        res.forEach(x => {
          let item = {
            name: x.Description,
            id: x.FacilityID
          }
          optionsList.push(item);
          this.facilitiesIds.push(x.FacilityID);
          this.facilities.push(x.FacilityID);
        });
        this.facilitiesList = optionsList;
        if (this.map) {
          this.initData();
        }
        // this.facilitiesList.length === this.params.FacilitiesIDs.length ? this.default.setValue(true) : this.default.setValue(false);
      }, 
      e => {
        this._appService.showException(e);
      }
    );
  }

  getDataPackages(): Observable<number> {
    this.executionNumber++;
    let executionNumber: number = this.executionNumber;
    return new Observable(observer => {
      if(!this._appService.onMapIconDetails.value) {
        setTimeout(() => {
          observer.next(); 
        }, 1000);
        return; 
      }
      this._coreProxyService.DeviceService.GetDeviceMapDataPacket(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this.facilitiesIds,
        this._sequenceNumber,
        150,
        success => {
          // Controlar que el request que se está ejecutando en este success sea el ultimo ejecutado por el programa
          if(executionNumber !== this.executionNumber) {
            this.firstExecution = false;
            observer.next();
            return;
          }
          try {
            if (this._sequenceNumber > success.HightestSequenceNumber) {
              return observer.next();
            }

            this._sequenceNumber = success.HightestSequenceNumber;

            if (this.firstExecution) {
              var sw = new google.maps.LatLng(success.InitialViewSW.Latitude, success.InitialViewSW.Longitude);
              var ne = new google.maps.LatLng(success.InitialViewNE.Latitude, success.InitialViewNE.Longitude);
              this.bounds = new google.maps.LatLngBounds(sw, ne);
                            
              this.initialLatitude = (sw.lat() + ne.lat()) / 2;
              this.initialLongitude = (sw.lng() + ne.lng()) / 2;
              this.initialZoom = 12; 
            
              this.centerMapInitially();
            }

            const sites = success.Devices;

            let refreshed = [];

            for (let index = 0; index < sites.length; index++) {
              refreshed.push(sites[index].DeviceID);
              this.addMarker(sites[index]);
            }

            if (this.firstExecution) {
              this.map.fitBounds(this.bounds);
              setTimeout(async () => {
                this.currentZoom = this.map.getZoom();
                this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
                if (this.currentZoom < this.CLUSTER_ZOOM_THRESHOLD) {
                  this._lastClusteringData = '';
                  this._isUpdatingClustering = false;
                  await this.updateClustering();
                } else {
                  if (this.clusterer) {
                    this.clusterer.clearMarkers();
                    this.clusterer = null;
                  }
                  this.showIndividualMarkersOnMap();
                }
              }, 100);
            } else {
              setTimeout(async () => {
                this.currentZoom = this.map.getZoom();
                this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
                if (this.currentZoom < this.CLUSTER_ZOOM_THRESHOLD) {
                  await this.updateClustering();
                } else {
                  if (this.clusterer) {
                    this.clusterer.clearMarkers();
                    this.clusterer = null;
                  }
                  this.showIndividualMarkersOnMap();
                }
              }, 100);
            }
            if(this._deviceID && this.devicesIDs.length > 0){
              let devices = this.clustersFullList.filter( item => this.devicesIDs.includes(item.deviceData.DeviceID));
              devices = this.clustersFullList.filter(item => this.devicesIDs.includes(item.deviceData.DeviceID) && this.facilitiesIds?.includes(item.deviceData.Facility.FacilityID));
              if(devices.length > 0 ){
                this.clustersFilteredList = [];
                this.clustersFilteredList = JSON.parse(JSON.stringify(devices));
              }
            }
            this.firstExecution = false;
            this.status = 1;
            observer.next();
          } catch (error) {
            observer.error(5000);
          }
        },
        err => {
          this.status = 2;
          this._appService.showException(err);
          observer.error(15000);
        }
      );
    });
  }

  addMarker(item: CoreTypes.DeviceMap) {
    if (!item.LocationAddress?.Location) { return; } 
    let index = this.indexTable.indexOf(item.DeviceID);
    let findCustomIcon = this._appService.onMapIconDetails.value.DevicesMapIcons.find(x => x.MapIconID === item.IconID);
    var image = {
      url: findCustomIcon ? findCustomIcon.Default : "assets/icons/default.png",
      size: new google.maps.Size(40, 40),
      scaledSize:  item.IconID === 0 ? new google.maps.Size(25, 40) : new google.maps.Size(32, 32)
    };

    // Definir marker segun las alarmas que tenga este item
    if (item.Stats.Alarms.AlarmCount.HighSeverity)
      image.url =  findCustomIcon ? findCustomIcon.High : "assets/icons/danger.png";
      else if (item.Stats.Alarms.AlarmCount.MidSeverity && !item.ShowGroupedAlarmsOnMaps)
      image.url = findCustomIcon ? findCustomIcon.Mid : "assets/icons/warning.png";
    else if (item.Stats.Alarms.AlarmCount.LowSeverity && !item.ShowGroupedAlarmsOnMaps)
      image.url = findCustomIcon ? findCustomIcon.Low :"assets/icons/low.png";
    else if ((item.Stats.Alarms.AlarmCount.LowSeverity || item.Stats.Alarms.AlarmCount.MidSeverity) && item.ShowGroupedAlarmsOnMaps)
      image.url = findCustomIcon ? findCustomIcon.Mid :  "assets/icons/warning.png";
    else if (item.Stats.Alarms.AlarmCount.InformationSeverity && !item.ShowGroupedAlarmsOnMaps)
      image.url =  findCustomIcon ? findCustomIcon.Information :"assets/icons/info.png";
    // Verificar si el elemento ya existe en el array.
    var markert: google.maps.Marker = new google.maps.Marker({
      icon: image
    });
    
    if (index > -1) {
      // Si ya existe, actualizar sus valores
      this.clustersFullList[index].deviceData = item;
      this.clustersFullList[index].markerData.url = markert.getIcon();
      this.clustersFullList[index].markerData.latitude = item.LocationAddress.Location.Latitude;
      this.clustersFullList[index].markerData.longitude = item.LocationAddress.Location.Longitude;

      // Si se realizó una busqueda, tambien actualizar los valores en ese listado filtrado.
      if(this.clustersFilteredList[index]) {
        this.clustersFilteredList[index].deviceData = item;
        this.clustersFilteredList[index].markerData.url = markert.getIcon();
        this.clustersFilteredList[index].markerData.latitude = item.LocationAddress.Location.Latitude;
        this.clustersFilteredList[index].markerData.longitude = item.LocationAddress.Location.Longitude;
      }
    } else {
      // Si no existe, agregarlo
      const cluster = {
        deviceData: item,
        markerData: {
          latitude: item.LocationAddress.Location.Latitude,
          longitude: item.LocationAddress.Location.Longitude,
          url: markert.getIcon(),
          metadata: { id: item.DeviceID },
          html: `
            <div class="marker-tooltip pb-2 pr-2">
              <div class="tooltip-header">
                <span class="tooltip-title text-primary">
                  <i class="fa-solid fa-server mr-1"></i> ${item.Description}
                </span>
                <span class="tooltip-close mb-1" onclick="window.dispatchEvent(new CustomEvent('close-info-window'))">✖</span>
              </div>
              <div class="tooltip-body mt-1">
                <span class="tooltip-description">
                  <i class="fa-solid fa-thumbtack mr-1"></i> ${item.Facility.Description}
                </span>
              </div>
            </div>
          `
        }
      };

      this.indexTable.push(item.DeviceID);
      this.clustersFullList.push(cluster);
      this.clustersFilteredList.push(cluster);
      this.facilityData = {
        Description: item.Facility.Description,
        FacilityID: item.Facility.FacilityID,
        ShowGroupedAlarmsOnMaps: item.ShowGroupedAlarmsOnMaps,
        IconID: null,
        Location: null,
        Stats: null
      }
      // Agregar bound para centrar el mapa en base a los markers, solo si es la primera carga del mapa.
      if (this.firstExecution) {
        this.bounds.extend(new google.maps.LatLng(item.LocationAddress.Location.Latitude, item.LocationAddress.Location.Longitude));
      }
    }
  }

  async onMapReady(map: google.maps.Map) {
    if(environment.useOfflineMode) {
      return;
    }
    this.map = map;
    this.mapApiReady = true;

    await this.loadMarkerLibraries();
    if(this._appService.getClientID()) {
      this.clientID = this._appService.getClientID();
      if (this.facilitiesIds.length > 0) {
        this.initData();
      }
    }

    this.subscriptions.push(this._appService.onFacilitySet.subscribe(_ => {
      const clientID = this._appService.getClientID();
      if (this.clientID === clientID) { return; }
      this.clientID = clientID;
      this.initData();
    }));
   
    this.currentZoom = this.map.getZoom();
    this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
   
  }

  private async loadMarkerLibraries() {
    try {
      const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
      this.AdvancedMarkerElement = AdvancedMarkerElement;
      this.PinElement = PinElement;
    } catch (error) {}
  }
  
  centerMapInitially() {
    if (!this.map) return;
  
    if (this.initialLatitude && this.initialLongitude) {
      this.map.setCenter(new google.maps.LatLng(this.initialLatitude, this.initialLongitude));
      if (this.initialZoom) {
        this.map.setZoom(this.initialZoom);
        this.currentZoom = this.initialZoom;
        this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
      }
    } else if (this.bounds) {
      this.map.fitBounds(this.bounds);
    }
  }
  

  onMarkerClick(marker: IconMarker) {
    this._appService.startLoading();
    this._coreProxyService.DeviceService.GetDeviceMapDetails(
      this._appService.getAccessToken(),
      marker.metadata.id,
      (details: CoreTypes.DeviceMapDetails) => {
        this._appService.stopLoading();
        this._deviceModalTextAttributes = details.TextAttributes;
        this._deviceModalId = details.DeviceID;
        this._deviceModal.open();
      }, () => {

      });
  }

  onFacilityModalClose() {
    this._deviceModalTextAttributes = [];
    this._deviceModalId = 0;
  }

  onCenterChange($event) {}

  boundsChange($event) {}

  onZoomChange($event) {
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      let newZoom = 0;
      if ($event && $event.target && typeof $event.target.getZoom === 'function') {
        newZoom = $event.target.getZoom();
      } else if (this.map && typeof this.map.getZoom === 'function') {
        newZoom = this.map.getZoom();
      }
      
      if (newZoom === this.currentZoom) { return; }
      
      const previousZoom = this.currentZoom;
      this.currentZoom = newZoom;
      const wasAboveThreshold = previousZoom >= this.CLUSTER_ZOOM_THRESHOLD;
      const isAboveThreshold = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
      
      if (isAboveThreshold && !wasAboveThreshold) {
        this.showIndividualMarkers = true;
        this.clearClustering();
        this.showIndividualMarkersOnMap();
        this.hideTooltip();
      } else if (!isAboveThreshold && wasAboveThreshold) {
        this.showIndividualMarkers = false;
        this.hideTooltip();
        
        if (this.markers && this.markers.length > 0) {
          this.markers.forEach(marker => {
            marker.setMap(null);
          });
          this.markers = [];
        }
        
        this._lastClusteringData = '';
        setTimeout(async () => {
          await this.updateClustering();
        }, 50);
      }
    }, 150);
  }

  private showIndividualMarkersOnMap() {
    if (!this.map || !this.showIndividualMarkers) {
      return;
    }
    if (this.markers.length === 0) {
      const devicesToShow = this.clustersFilteredList.length > 0 ? 
        this.clustersFilteredList : this.clustersFullList;

      devicesToShow
        .filter(device =>
          device.deviceData.LocationAddress?.Location?.Latitude != null &&
          device.deviceData.LocationAddress?.Location?.Longitude != null
        )
        .forEach((device) => {
          const lat = device.deviceData.LocationAddress.Location.Latitude;
          const lng = device.deviceData.LocationAddress.Location.Longitude;
          
          const icon = this.getDeviceIcon(device.deviceData);
          const marker = new google.maps.Marker({
            position: { lat, lng },
            icon: icon,
            title: device.deviceData.Description,
            map: this.map
          });
          
          marker.addListener("click", () => {
            this.onMarkerClick(device.markerData);
          });

          marker.addListener("mouseover", () => {
            this._currentTooltipMarker = marker;
            
            if (this._tooltipTimeout) {
              clearTimeout(this._tooltipTimeout);
              this._tooltipTimeout = null;
            }
            this.showTooltip(marker, device);
          });

          marker.addListener("mouseout", () => {
            this._tooltipTimeout = setTimeout(() => {
              if (!this._isMouseOverTooltip) {
                this.hideTooltip();
                this._currentTooltipMarker = null;
              }
            }, 200);
          });
          
          (marker as any).deviceData = device.deviceData;
          (marker as any).deviceId = device.deviceData.DeviceID;
          
          this.markers.push(marker);
        });
    } else {
      this.markers.forEach(marker => {
        if (marker.getMap() !== this.map) {
          marker.setMap(this.map);
        }
      });
    }
  }

  search(e: any) {
    let value: string = this._accentFoldService.accentFold(e.target.value.toLowerCase());

    if(value.length > 0) {
      this.clustersFilteredList = [];

      this.clustersFullList.forEach((item) => {
        let displayText = this._accentFoldService.accentFold(item.deviceData.Facility.Description.toLowerCase());
        let description = this._accentFoldService.accentFold(item.deviceData.Description.toLowerCase());
        if(displayText.indexOf(value) > -1 || description.indexOf(value) > -1 || item.deviceData.DeviceID == parseInt(value)) {
          this.clustersFilteredList.push(item);
        }
      });
    } else {
      this.clustersFilteredList = this.clustersFullList;
    }
  }

  goToWithDevice(facility, device: CoreTypes.DeviceMap, route: string) {
    this.sharedService.goToWithFacilityOrDevice(facility, route, device);
  }

  openCameraModal(link: string) {
    return this._router.navigate(['/', {outlets: {modal: ['camera', btoa(link)]}}]);
  }

  applyFilters(controlName:string) {
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      let find = [];
      let sites = [];
      this.clustersFilteredList = [];
      if(controlName === 'facilities'){
        find = this.clustersFullList.filter(item => this.facilitiesIds.includes(item.deviceData.Facility.FacilityID));
        if(find.length > 0 && this.devicesIDs.length && this.facilitiesIds.length > 0) {
          find = this.clustersFullList.filter(item => this.devicesIDs.includes(item.deviceData.DeviceID) && this.facilitiesIds.includes(item.deviceData.Facility.FacilityID));
        }

        if(find.length > 0 && this.facilitiesIds.length > 0) {
          for(let i = 0; i < find.length; i++) {
            let device = find[i];
            sites.push(device);
            this.clustersFilteredList.push(device);
            this.addMarker(device.deviceData);
          }
        }
      } else if (controlName === 'devices'){
        let findDevice = [];
        findDevice = this.clustersFullList.filter(item => this.devicesIDs.includes(item.deviceData.DeviceID));
        findDevice = this.clustersFullList.filter(item => this.devicesIDs.includes(item.deviceData.DeviceID) && this.facilitiesIds?.includes(item.deviceData.Facility.FacilityID));
        if(findDevice.length > 0 && this.devicesIDs.length > 0) {
          for(let i = 0; i < findDevice.length; i++) {
            let device = findDevice[i];
            sites.push(device);
            this.clustersFilteredList.push(device);
            this.addMarker(sites[i].deviceData);
          }
        }
      }
    }, 300);
  }

  loadDevices(): Promise<void> {
    this.devicesOpts = [];
    this.devicesFullList = [];
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    let sites = [];
    return new Promise((resolve) => {
      this._coreProxyService.DeviceService.EnumDevicesByClientID(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        res => {
          this.devicesFullList = res;
          res.forEach(x => {
            let item = {
              name: x.Description,
              id: x.DeviceID
            }
            if(x.GeoLocation) optionsList.push(item);
          });
          this.devicesOpts = optionsList;
          let device = this.devicesOpts.find( x => x.id == this._deviceID ).id;
          this.devicesIDs.push(device);
          resolve();
        },
        e => {
          this._appService.showException(e);
        }
      );
    });
  }

  async updateClustering() {
    if ((!this.map || this._isUpdatingClustering) || (this.clusterer && this._lastClusteringData !== '')) {
      return;
    }
    
    if (this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD) {
      this.clearClustering();
      return;
    }
    
    if (!this.map.getDiv() || !(this.map.getDiv() as HTMLElement).offsetWidth) {
      setTimeout(async () => await this.updateClustering(), 100);
      return;
    }
    
    if (this.clustersFilteredList.length === 0) {
      this.clustersFilteredList = [...this.clustersFullList];
    }

    // Verificar que las librerías de marcadores estén cargadas
    if (!this.AdvancedMarkerElement || !this.PinElement) {
      await this.loadMarkerLibraries();
    }

    const currentData = JSON.stringify(this.clustersFilteredList.map(item => ({
      id: item.deviceData.DeviceID,
      lat: item.deviceData.LocationAddress?.Location?.Latitude,
      lng: item.deviceData.LocationAddress?.Location?.Longitude,
      severity: this.getHighestSeverity(item.deviceData)
    })));
    
    const currentFacilityId = this._appService.getFacilityID();
    const facilityChanged = this._lastFacilityId !== currentFacilityId;
    
    if (currentData === this._lastClusteringData && this.clusterer && this.markers.length > 0 && this._lastClusteringData !== '' && !facilityChanged) {
      return;
    }
    
    if (facilityChanged) {
      this._lastFacilityId = currentFacilityId;
    }
    
    this._lastClusteringData = currentData;
    this._isUpdatingClustering = true;
    
    try {
      if (this.clusterer) {
        this.clusterer.clearMarkers();
        this.clusterer = null;
      }
      
      // Solo limpiar marcadores si no estamos en modo individual
      if (!this.showIndividualMarkers && this.markers && this.markers.length > 0) {
        this.markers.forEach(marker => {
          marker.setMap(null);
        });
        this.markers = [];
      }
      
      const markersByPosition = new Map<string, any[]>();
      
      this.clustersFilteredList
        .filter(device =>
          device.deviceData.LocationAddress?.Location?.Latitude != null &&
          device.deviceData.LocationAddress?.Location?.Longitude != null
        ).forEach((device) => {
          const lat = device.deviceData.LocationAddress.Location.Latitude;
          const lng = device.deviceData.LocationAddress.Location.Longitude;
          const positionKey = `${lat.toFixed(6)},${lng.toFixed(6)}`;
          
          if (!markersByPosition.has(positionKey)) {
            markersByPosition.set(positionKey, []);
          }
          markersByPosition.get(positionKey).push(device);
      });

      this.markers = Array.from(markersByPosition.entries()).map(([positionKey, devices]) => {
        let selectedDevice = devices[0];
        let maxSeverity = this.getHighestSeverity(devices[0].deviceData);
        
        if (devices.length > 1) {
          for (let i = 1; i < devices.length; i++) {
            const device = devices[i];
            const severity = this.getHighestSeverity(device.deviceData);
            if (severity === 'high' && maxSeverity !== 'high') {
              maxSeverity = 'high';
              selectedDevice = device;
              break;
            } else if (severity === 'mid' && maxSeverity !== 'high' && maxSeverity !== 'mid') {
              maxSeverity = 'mid';
              selectedDevice = device;
            } else if (severity === 'low' && maxSeverity !== 'high' && maxSeverity !== 'mid' && maxSeverity !== 'low') {
              maxSeverity = 'low';
              selectedDevice = device;
            }
          }
        }
        
        const lat = selectedDevice.deviceData.LocationAddress.Location.Latitude;
        const lng = selectedDevice.deviceData.LocationAddress.Location.Longitude;
        const severity = this.getHighestSeverity(selectedDevice.deviceData);
        
        const icon = this.getDeviceIcon(selectedDevice.deviceData);
        const marker = new google.maps.Marker({
          position: { lat, lng },
          icon: icon,
          title: devices.length > 1 ? 
            `${devices.length} dispositivos - ${selectedDevice.deviceData.Description}` : 
            selectedDevice.deviceData.Description,
          map: null
        });
        
        marker.addListener("click", () => {
          this.onMarkerClick(selectedDevice.markerData);
        });

        marker.addListener("mouseover", () => {
          this._currentTooltipMarker = marker;
          
          if (this._tooltipTimeout) {
            clearTimeout(this._tooltipTimeout);
            this._tooltipTimeout = null;
          }
          this.showTooltip(marker, selectedDevice);
        });

        marker.addListener("mouseout", () => {
          this._tooltipTimeout = setTimeout(() => {
            if (!this._isMouseOverTooltip) {
              this.hideTooltip();
              this._currentTooltipMarker = null;
            }
          }, 200);
        });
        
        (marker as any).severity = severity;
        (marker as any).deviceData = selectedDevice.deviceData;
        (marker as any).deviceId = selectedDevice.deviceData.DeviceID;
        (marker as any).allDevices = devices;
        
        return marker;
      });
      
      const validMarkers = this.markers.filter(marker => {
        const position = marker.getPosition();
        return position && position.lat() !== 0 && position.lng() !== 0;
      });
      
      
      if (validMarkers.length > 0) {
        this.clusterer = new MarkerClusterer({
          map: this.map,
          markers: validMarkers,
          gridSize: 300,
          renderer: {
            render: ({ count, position, markers }) => {
              let maxSeverity = 'none';
              
              for (let i = 0; i < markers.length; i++) {
                const severity = (markers[i] as any).severity;
                if (severity === 'high') {
                  maxSeverity = 'high';
                  break;
                } else if (severity === 'mid' && maxSeverity !== 'high') {
                  maxSeverity = 'mid';
                } else if (severity === 'low' && maxSeverity !== 'high' && maxSeverity !== 'mid') {
                  maxSeverity = 'low';
                }
              }
              
              const color = this.getColorBySeverity(maxSeverity);
              const svg = `
                <svg xmlns="http://www.w3.org/2000/svg" height="54" width="54">
                  <circle cx="27px" cy="27px" r="16px" fill-opacity="0.5" fill="${color}"/> 
                  <circle cx="27px" cy="27px" r="18px" fill-opacity="0.8" fill="${color}"/>
                  <circle cx="27px" cy="27px" r="20px" fill-opacity="0.5" fill="${color}"/>
                  <circle cx="27px" cy="27px" r="22px" fill-opacity="0.20" fill="${color}"/>
                  <circle cx="27px" cy="27px" r="24px" fill-opacity="0.30" fill="${color}"/>
                  <text x="27px" y="32px" text-anchor="middle" font-size="14" font-family="Arial" fill="white" font-weight="bold">${count}</text>
                </svg>
              `;
              const div = document.createElement("div");
              div.innerHTML = svg;
              const clusterMarker = new this.AdvancedMarkerElement({
                position,
                content: div,
              });
              
              clusterMarker.addListener("click", () => {
                if (count > 1) {
                  const bounds = new google.maps.LatLngBounds();
                  markers.forEach(marker => {
                    bounds.extend(marker.getPosition() as google.maps.LatLng);
                  });
                  this.map.fitBounds(bounds, 50);
                }
              });
              
              return clusterMarker;
            }
          }
        } as any);
      } 
    } catch (error) {
    } finally {
      this._isUpdatingClustering = false;
    }
  }

  private clearClustering() {
    if (this.clusterer) {
      this.clusterer.clearMarkers();
      this.clusterer = null;
    }
    
    if (this.markers && this.markers.length > 0) {
      this.markers.forEach(marker => {
        marker.setMap(null);
      });
      this.markers = [];
    }
    
    this._lastClusteringData = '';
  }

  
  private showTooltip(marker: google.maps.Marker, device: any) {
    if (!this.infoWindow) {
      this.infoWindow = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: true,
        pixelOffset: new google.maps.Size(0, -40),
        maxWidth: 300
      });
    }

    let targetDevice = device;
    const allDevices = (marker as any).allDevices;
    if (allDevices && allDevices.length > 1) {
      const specificDevice = allDevices.find(d => d.deviceData.DeviceID === device.deviceData.DeviceID);
      if (specificDevice) {
        targetDevice = specificDevice;
      }
    }

    this.infoWindow.setContent(targetDevice.markerData.html);
    this.infoWindow.setPosition(marker.getPosition());
    this.infoWindow.open(this.map);
  }

  private hideTooltip() {
    if (this.infoWindow) {
      this.infoWindow.close();
    }
  }
  
  private getDeviceSeverity(device: CoreTypes.DeviceMap): string {
    if (device.Stats.Alarms.AlarmCount.HighSeverity) {
      return 'high';
    } else if (device.Stats.Alarms.AlarmCount.MidSeverity && !device.ShowGroupedAlarmsOnMaps) {
      return 'mid';
    } else if (device.Stats.Alarms.AlarmCount.LowSeverity && !device.ShowGroupedAlarmsOnMaps) {
      return 'low';
    } else if ((device.Stats.Alarms.AlarmCount.LowSeverity || device.Stats.Alarms.AlarmCount.MidSeverity) && device.ShowGroupedAlarmsOnMaps) {
      return 'mid';
    } else if (device.Stats.Alarms.AlarmCount.InformationSeverity && !device.ShowGroupedAlarmsOnMaps) {
      return 'info';
    }
    return 'normal';
  }

  private getIconUrlBySeverity(iconId: number, severity: string, size: { width: number, height: number } = { width: 32, height: 32 }): any {
    const findCustomIcon = this._appService.onMapIconDetails.value?.DevicesMapIcons?.find(x => x.MapIconID === iconId);
    const findDefaultIcon = this._appService.onMapIconDetails.value?.DevicesMapIcons?.find(x => x.MapIconID === 0);
    
    let iconUrl: string;
    
    if (findCustomIcon) {
      switch (severity) {
        case 'high':
          iconUrl = findCustomIcon.High || findCustomIcon.Default;
          break;
        case 'mid':
          iconUrl = findCustomIcon.Mid || findCustomIcon.Default;
          break;
        case 'low':
          iconUrl = findCustomIcon.Low || findCustomIcon.Default;
          break;
        case 'info':
          iconUrl = findCustomIcon.Information || findCustomIcon.Default;
          break;
        default:
          iconUrl = findCustomIcon.Default;
      }
    } else {
      switch (severity) {
        case 'high':
          iconUrl = findDefaultIcon ? findDefaultIcon.High : "assets/icons/danger.png";
          break;
        case 'mid':
          iconUrl = findDefaultIcon ? findDefaultIcon.Mid : "assets/icons/warning.png";
          break;
        case 'low':
          iconUrl = findDefaultIcon ? findDefaultIcon.Low : "assets/icons/low.png";
          break;
        case 'info':
          iconUrl = findDefaultIcon ? findDefaultIcon.Information : "assets/icons/info.png";
          break;
        default:
          iconUrl = findDefaultIcon ? findDefaultIcon.Default : "assets/icons/default.png";
      }
    }
    
    return {
      url: iconUrl,
      size: new google.maps.Size(size.width, size.height),
      scaledSize: new google.maps.Size(size.width, size.height)
    };
  }

  private getDeviceIcon(device: CoreTypes.DeviceMap, size: { width: number, height: number } = { width: 32, height: 32 }): any {
    const severity = this.getDeviceSeverity(device);
    const iconSize = device.IconID === 0 ? { width: 25, height: 40 } : size;
    return this.getIconUrlBySeverity(device.IconID, severity, iconSize);
  }

  
  getHighestSeverity(device: any): 'high' | 'mid' | 'low' | 'none' {
    const alarms = device.Stats?.Alarms?.AlarmCount || {};
    if (alarms.HighSeverity > 0) return 'high';
    if (alarms.MidSeverity > 0) return 'mid';
    if (alarms.LowSeverity > 0) return 'low';
    return 'none';
  }

  getColorBySeverity(severity: string): string {
    switch (severity) {
      case 'high': return '#e74c3c';
      case 'mid': return '#e67e22';
      case 'low': return '#f1c40f';
      default: return '#2ecc71';
    }
  }

  private findMarkerForDevice(deviceId: number): google.maps.Marker | null {
    const directMarker = this.markers.find(m => (m as any).deviceId === deviceId);
    if (directMarker) {
      return directMarker;
    }
    for (const marker of this.markers) {
      const allDevices = (marker as any).allDevices;
      if (allDevices && allDevices.some(d => d.deviceData.DeviceID === deviceId)) {
        return marker;
      }
    }
    return null;
  }

  onCardHover(item: any) {
    this._activeMarker = item.deviceData.DeviceID;
    const lat = item.deviceData.LocationAddress?.Location?.Latitude;
    const lng = item.deviceData.LocationAddress?.Location?.Longitude;
    if (this.map && lat && lng && lat !== 0 && lng !== 0) {
      const position = new google.maps.LatLng(lat, lng);
      this.map.panTo(position);
    } else {
      return;
    }
    
    const marker = this.findMarkerForDevice(item.deviceData.DeviceID);
    if (marker) {
      this._currentTooltipMarker = marker;
      this.showTooltip(marker, item);
    }
  }
  
  onCardMouseOut() {
    this._activeMarker = 0;
    if (this._currentTooltipMarker) {
      this.hideTooltip();
      this._currentTooltipMarker = null;
    }
  }
}
